import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const AdminPageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: stretch;
  padding: 24px 16px;
`;

export const AdminShell = styled.div`
  width: 100%;
  max-width: 1400px;
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

export const AdminSidebar = styled.aside`
  background: linear-gradient(180deg, #1b5e20, #2e7d32);
  color: #ffffff;
  padding: 24px 18px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const AdminBrand = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
`;

export const AdminNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AdminNavLink = styled(NavLink)`
  display: block;
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 0.9rem;
  color: #e0f2f1;
  text-decoration: none;
  transition: background-color 0.15s ease, color 0.15s ease;

  &.active {
    background-color: #f5debb;
    color: #1b5e20;
  }

  &:hover {
    background-color: rgba(245, 222, 187, 0.22);
    color: #ffffff;
  }
`;

export const AdminSidebarFooter = styled.div`
  margin-top: auto;
  font-size: 0.8rem;
  opacity: 0.85;
`;

export const AdminMain = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
`;

export const AdminHeader = styled.header`
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background-color: #ffffff;
`;

export const AdminHeaderTitle = styled.h1`
  margin: 0;
  font-size: 1.2rem;
`;

export const AdminHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AdminHeaderUser = styled.div`
  font-size: 0.9rem;
  color: #555555;
`;

export const AdminButton = styled.button`
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid #2e7d32;
  background-color: #ffffff;
  color: #2e7d32;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
`;

export const AdminLinkButton = styled(AdminButton).attrs({ as: 'a' })``;

export const AdminContent = styled.main`
  padding: 24px;
  flex: 1;
  overflow-y: auto;
`;

export const AdminSectionTitle = styled.h2`
  margin: 0 0 12px;
  font-size: 1.1rem;
`;

export const AdminSectionText = styled.p`
  font-size: 0.95rem;
  line-height: 1.6;
`;

export const AdminLoginWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
`;

export const AdminLoginCard = styled.div`
  width: 100%;
  max-width: 420px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  padding: 24px 24px 20px;
`;

export const AdminLoginTitle = styled.h1`
  margin: 0 0 12px;
  font-size: 1.3rem;
`;

export const AdminLoginField = styled.div`
  margin-bottom: 12px;
`;

export const AdminLoginLabel = styled.label`
  display: block;
  font-size: 0.85rem;
  margin-bottom: 4px;
`;

export const AdminLoginInput = styled.input`
  width: 100%;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #cccccc;
  font-size: 0.9rem;
`;

export const AdminLoginError = styled.div`
  margin-bottom: 10px;
  font-size: 0.85rem;
  color: #b71c1c;
`;

export const AdminLoginActions = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const AdminLoginButton = styled.button`
  padding: 8px 16px;
  border-radius: 999px;
  border: none;
  background-color: #1b5e20;
  color: #ffffff;
  font-size: 0.9rem;
  cursor: pointer;
`;

export const AdminSaveButton = styled(AdminLoginButton)`
  background-color: #1565C0;
  padding: 10px 24px;
  font-size: 1rem;
  box-shadow: 0 4px 6px rgba(21, 101, 192, 0.2);
  
  &:hover {
    background-color: #0d47a1;
  }
  
  &:disabled {
    background-color: #90caf9;
    cursor: not-allowed;
  }
`;

export const AdminSecondaryLink = styled.a`
  font-size: 0.85rem;
  color: #2e7d32;
  text-decoration: none;
`;
